import React from "react";
import { MepaShowcase } from "@/components/MepaShowcase";
import { HomeHero } from "@/components/home/HomeHero";
import { HeroSearch } from "@/components/home/HeroSearch";
import { HomeCategories } from "@/components/home/HomeCategories";
import { HomeCta } from "@/components/home/HomeCta";
import { FeaturedCarousel } from "@/components/home/FeaturedCarousel";
import { StatsBand } from "@/components/home/StatsBand";

export default function Home() {
  return (
    <div className="bg-white text-aic-navy" data-testid="home-page">
      <HomeHero/>
      <div className="relative z-10 max-w-6xl mx-auto px-6 -mt-24 md:-mt-28">
        <HeroSearch/>
      </div>
      <HomeCategories/>
      <HomeCta/>
      <FeaturedCarousel/>
      <MepaShowcase/>
      <StatsBand/>
    </div>
  );
}
